import React from 'react'
import { convertToKebabCase } from '../../utils'
import Icon from '../icon'
import { Wrapper, TextSpacer } from './styles'
import { Skeleton } from '@material-ui/lab'
import LoadingSpinner from './loading-spinner'

type Props = {
  children?: any
  'data-qa'?: string
  disabled?: boolean
  icon?: string
  isFullWidth?: boolean
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void
  style?: object
  theme?: 'danger' | 'positive' | 'primary' | 'secondary' | 'tertiary'
  type?: 'button' | 'submit'
  isLoading?: boolean
  isSkeleton?: boolean
}

const Button: React.FC<Props> = (props: Props): JSX.Element => {
  const isIconOnly = props.icon && !props.children
  const classes = composeClasses(props, isIconOnly)
  const dataQa = composeDataQa(props)

  function loadingIcon() {
    return <LoadingSpinner />
  }

  function buttonChildren() {
    return (
      <>
        {props.icon && <Icon name={props.icon} />}

        {props.icon && !isIconOnly && <TextSpacer />}

        {props.children}
      </>
    )
  }

  return (
    <>
      {props.isSkeleton && !props.isFullWidth ? (
        <Skeleton
          height={'4rem'}
          width={isIconOnly ? '4rem' : '12rem'}
          variant="rect"
        />
      ) : (
        <Wrapper
          className={classes}
          style={props.style}
          disabled={props.disabled}
          onClick={(event) => !props.isLoading && props.onClick(event)}
          type={props.type}
          data-qa={dataQa}
        >
          {props.isLoading ? loadingIcon() : buttonChildren()}
        </Wrapper>
      )}
    </>
  )
}

Button.defaultProps = {
  theme: 'primary',
  type: 'button',
}

export default Button

function composeDataQa(props: Props): string {
  const buttonName = props.children || props.icon

  const id = props['data-qa'] || convertToKebabCase(buttonName?.toString())

  return `button-${id}`
}

export function composeClasses(props: Props, isIconOnly: boolean) {
  return props.theme
    .concat(' ')
    .concat(' ')
    .concat(props.isFullWidth ? 'full-width' : '')
    .concat(' ')
    .concat(isIconOnly ? 'icon-only' : '')
}
